import { Button } from '@/components/ui/button';
import { RateLimit } from '@/types';

interface RefreshButtonProps {
  onClick: () => void;
  loading: boolean;
  rateLimit: RateLimit;
}

function formatResetTime(dateStr: string): string {
  const date = new Date(dateStr);
  const now = new Date();
  const diffMs = date.getTime() - now.getTime();
  const diffMins = Math.max(0, Math.ceil(diffMs / (1000 * 60)));

  if (diffMins < 1) return 'now';
  if (diffMins < 60) return `${diffMins}m`;
  return `${Math.ceil(diffMins / 60)}h`;
}

export function RefreshButton({ onClick, loading, rateLimit }: RefreshButtonProps) {
  const { remaining_attempts, reset_at } = rateLimit;
  const canRefresh = remaining_attempts > 0;

  return (
    <div className="flex items-center gap-2">
      <Button
        variant="outline"
        size="sm"
        onClick={onClick}
        disabled={loading || !canRefresh}
      >
        {loading ? (
          <>
            <svg className="animate-spin h-4 w-4 mr-2" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            Refreshing...
          </>
        ) : (
          <>
            <svg className="h-4 w-4 mr-2" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182m0-4.991v4.99" />
            </svg>
            Refresh
          </>
        )}
      </Button>
      <span className="text-xs text-gray-500">
        {remaining_attempts}/5 remaining
        {remaining_attempts === 0 && ` (resets in ${formatResetTime(reset_at)})`}
      </span>
    </div>
  );
}
